const ConvertGramsToKilo = (value: number, reverse: boolean) =>
	parseFloat((reverse ? value / 1000 : value * 1000).toFixed(4));

const ConvertCmToInches = (value: number, reverse: boolean) =>
	parseFloat((reverse ? value / 2.54 : value * 2.54).toFixed(2));

export { ConvertGramsToKilo, ConvertCmToInches };
